module.exports = __webpack_public_path__ + "img/noise.b4f5fb65.png";